import qs from 'qs'

export const createDynamicPath = (params: Array<string | number>) => params.join('/')
export const createQueryString = params => qs.stringify(params, { encodeValuesOnly: true })
